import * as React from 'react';
const { useState } = React;
const h = React.createElement;
import { Button } from './Button';

export interface PopconfirmProps {
  title?: React.ReactNode;
  onConfirm?: () => void;
  onCancel?: () => void;
  children?: React.ReactNode;
  okText?: string;
  cancelText?: string;
  /**
   * 弹层水平对齐方式，默认 left（向左展开，与触发元素左边缘对齐）。
   *
   * 表格「操作」列通常位于最右侧，默认向左展开会让 min-w-[240px] 的弹层
   * 超出视口右边界而被截断，此时应传 'right' 让弹层向左展开。
   */
  align?: 'left' | 'right';
}

const Popconfirm: React.FC<PopconfirmProps> = function Popconfirm(props) {
  const {
    title,
    onConfirm,
    onCancel,
    children,
    okText = 'OK',
    cancelText = 'Cancel',
    align = 'left',
  } = props;
  const [visible, setVisible] = useState(false);

  return h(
    'div',
    { className: 'relative inline-block' },
    h('div', { onClick: () => setVisible(true) }, children),
    visible &&
      h(
        'div',
        {
          className: `absolute z-50 mt-2 bg-dark-800 border border-dark-700 rounded-lg shadow-xl p-4 min-w-[240px] ${align === 'right' ? 'right-0' : 'left-0'}`,
        },
        h('div', { className: 'text-sm text-dark-200 mb-3' }, title),
        h(
          'div',
          { className: 'flex justify-end gap-2' },
          h(
            Button,
            {
              size: 'small',
              onClick: () => {
                setVisible(false);
                if (onCancel) onCancel();
              },
            },
            cancelText,
          ),
          h(
            Button,
            {
              size: 'small',
              type: 'primary',
              onClick: () => {
                setVisible(false);
                if (onConfirm) onConfirm();
              },
            },
            okText,
          ),
        ),
      ),
  );
};

export { Popconfirm };
